import { Timesplit } from '~/types/Timesplit';

export const templateIdByType: { [key: string]: Array<number> } = {
  '50-50': [1, 2, 3, 12, 13, 14, 15],
  '60-40': [9, 11],
  '70-30': [7, 8, 10],
  '80-20': [4],
};

export const timesplitToId: { [key: string]: number } = {
  '50-50': 1,
  '60-40': 2,
  '70-30': 3,
  '80-20': 4,
};

export const templateToTimesplit = new Map<number, number>([
  [1, 1],
  [2, 1],
  [3, 1],
  [12, 1],
  [13, 1],
  [14, 1],
  [15, 1],
  [9, 2],
  [11, 2],
  [7, 3],
  [8, 3],
  [10, 3],
  [4, 4],
]);

export const validTimeSplits: Timesplit[] = ['50-50', '60-40', '70-30', '80-20'];

// The "Custom" template is not part of a timesplit category - the user draws the pattern themselves,
// so the split is only known once the schedule is built.
export const CUSTOM_TEMPLATE_ID = 6;
export const CUSTOM_CATEGORY_ID = 5;
export const CUSTOM_TIMESPLIT = 'custom';
export const MIN_CUSTOM_WEEKS = 1;
export const MAX_CUSTOM_WEEKS = 4;
